<template>
    <div class="form-group" :class="{'has-error': errors.has(inputId)}">
        <label :for="inputId" v-html="deleteTags(label)"></label><label v-if="required" class="red"> *</label>
        <textarea :id="inputId" v-model="inputVal" v-validate="validations" :data-vv-as="''"
                  :name="inputId" class="form-control" rows="5" :disabled="isEditable()"></textarea>
    <span class="md-error" v-if="required && errors.collect(inputId).length && inputVal=='' " >
      {{t('This field is required.')}}
    </span>
    <span class="md-error" v-else>{{ errors.first(inputId) }}</span>
    </div>
</template>

<script>
    export default {
        name: "checkout-form-textarea",
        props: ['value', 'label', 'required', 'inputValidations', 'uniqueId', 'notEditable','level_access'],
        inject: ['$validator'],
        data() {
            return {
                inputVal: this.value,
                // Valor con el que cargó el campo; el bloqueo por notEditable se decide contra
                // este y no contra el valor vivo (si no, se deshabilita al primer carácter).
                initialValue: this.value,
                inputId: null
            }
        },
        computed: {
            _() {
                return _;
            },
            validations() {
                let validations = {};

                if (this.required) {
                    validations.required = true;
                }

                if (this.inputValidations) {
                    const dbValidations = JSON.parse(this.inputValidations);
                    validations = Object.assign(validations, dbValidations);
                }


                return validations;
            }
        },
        watch: {
            value(val) {
                // Solo los cambios externos (carga o prefill) redefinen el valor inicial.
                if (val !== this.inputVal) {
                    this.initialValue = val;
                }
                this.inputVal = val;
            },
            inputVal(val) {
                this.$emit('input', val);
            }
        },
        created() {
            this.inputId = this.uniqueId || _.uniqueId();
        },
        methods:{
          deleteTags(label){
            //let result = label.replace(/<[^>]*>?/gm, '');
            let result = label.replace(/\s*style=(["'])(.*?)\1/gmi, '')
            .replace(/<p[^>]*>/gmi, '');
            
            return result;
          },
          // OJO: devuelve si el campo está BLOQUEADO (se usa en :disabled), no lo contrario.
          isEditable() {
                return !!this.initialValue && this.notEditable == 1 && this.level_access !== 1;
            },
        }
    }
</script>

<style scoped>
    .red {
        color: #D95A4B !important;
    }
</style>
